import * as XLSX from 'xlsx';
import { locale as appLocale } from './units';
import { download } from './exporters';

export const num = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return Number.isFinite(n) ? n : 0; };
export const woodPiles = (tr) => (tr.wps || []).filter((w) => w.kind === 'woodPile');
export const WOOD_SORTS = ['log', 'ind', 'fire', 'energy', 'short'];
export const WOOD_GRADES = ['A', 'B', 'C', 'D'];

// Huber formula: pieces x pi/4 x (mid diameter in m)^2 x length; falls back to the manual Festmeter value
export const woodVol = (d = {}) => {
  const l = num(d.len), dm = num(d.dia) / 100, n = num(d.count) || 1;
  return l > 0 && dm > 0 ? Math.round(n * Math.PI / 4 * dm * dm * l * 100) / 100 : num(d.volume);
};
// stores the computed volume so lists, labels and exports show it
export const woodData = (d = {}) => {
  const o = { ...d, grade: (d.grade || '').trim() };
  if (num(d.len) > 0 && num(d.dia) > 0) o.volume = String(woodVol(d)).replace('.', ',');
  return Object.fromEntries(Object.entries(o).filter(([, v]) => v !== '' && v != null));
};

const sumBy = (rows, col) => {
  const o = {};
  rows.forEach((r) => { const k = r[col] || '–'; o[k] = (o[k] || 0) + r[8]; });
  return Object.entries(o).map(([k, v]) => ['', k, '', '', '', '', '', '', +v.toFixed(2)]);
};

// timber list of one forest walk: one row per wood pile + totals per species and assortment
export function exportWoodXLSX(tr, t) {
  const list = woodPiles(tr);
  const head = [t.woodNo, t.woodRef, t.wpF_species, t.wpF_sort, t.wpF_grade, t.wpF_len, t.wpF_dia, t.wpF_count, t.wpF_volume, t.colNote, t.woodDate, 'Lat', 'Lon'];
  const rows = list.map((w, i) => {
    const d = w.data || {};
    return [i + 1, `R${tr.no || 1}-P${w.no || i + 1}`, d.species || '', d.sort || '', d.grade || '', num(d.len) || '', num(d.dia) || '', num(d.count) || (num(d.len) ? 1 : ''), woodVol(d), w.note || '', new Date(w.t).toLocaleString(appLocale()), +w.lat.toFixed(7), +w.lon.toFixed(7)];
  });
  const sum = rows.reduce((a, r) => a + r[8], 0);
  const ws = XLSX.utils.aoa_to_sheet([[`${t.woodTitle}: ${tr.name}`], [], head, ...rows, [], ['', t.woodSum, '', '', '', '', '', '', +sum.toFixed(2)],
    [], [t.woodBySpecies], ...sumBy(rows, 2), [], [t.woodBySort], ...sumBy(rows, 3)]);
  ws['!cols'] = [5, 12, 18, 18, 12, 10, 12, 8, 12, 30, 18, 12, 12].map((wch) => ({ wch }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, t.woodSheet);
  const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  download(new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${(tr.name || 'Begehung').replace(/[^\p{L}\p{N}-]+/gu, '_').slice(0, 70)}_Holzliste.xlsx`);
  return sum;
}
